import { render, staticRenderFns } from "./FleetTruckInformation.vue?vue&type=template&id=4819492c&scoped=true&"
import script from "./FleetTruckInformation.vue?vue&type=script&lang=js&"
export * from "./FleetTruckInformation.vue?vue&type=script&lang=js&"
import style0 from "./FleetTruckInformation.vue?vue&type=style&index=0&id=4819492c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4819492c",
  null
  
)

export default component.exports